module.exports = __webpack_public_path__ + "static/media/eg.1e73d423.svg";